import { Pressable, View } from "react-native";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import styles from './AddButton.styles'

type AddButtonProps = {
  onPress: () => void
}

export default function AddButton({onPress}: AddButtonProps){
  return(
    <View style={styles.fabContainer}>
      <Pressable
        style={({ pressed }) => [
          styles.fab,
          pressed && styles.fabPressed
        ]}
        onPress={onPress}
        android_ripple={{ color: 'rgba(255, 255, 255, 0.2)', radius: 28 }}
        testID="BT_ADD_ABSENCE"
      >
        <MaterialCommunityIcons 
          name="plus" 
          size={24}
          style={styles.fabIcon}
        />
      </Pressable>
    </View>
  )
}